import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./AtmDetailsView.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import MapWrapper from "../../../../Components/UiComponents/MapWrapper/MapWrapper";

// Component function to display ATM view form
const AtmDetailsView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { atm, bank, branch } = location.state || {};
  const [selectedMapOption, setSelectedMapOption] = useState("CC Camera");

  useEffect(() => {
    if (!atm) {
      navigate("../all-atms"); // Auto go back
    }
  }, [atm, navigate]);

  if (!atm) return null;

  // Map configuration for MapWrapper
  const mapTitle = "ATM Location";

  //Map Lat Long coordinates
  const mapCoordinates = [
    {
      x: atm?.latitude || 25.4223,
      y: atm?.longitude || 86.1391,
      locationId: 1,
      popupdata: {
        title: atm?.name,
        description: atm?.addressLine,
        status: atm?.activeStatus ? "Active" : "Inactive",
        // type: incidentData?.eventType,
        type: "ATM",
      },
    },
  ];

  // Handler for map dropdown change
  const handleMapOptionChange = (e) => {
    setSelectedMapOption(e.target.value);
  };

  // Handler for recording chosen coordinates if needed
  const handleChooseCoordinates = (longitude, latitude) => {
    console.log(`Selected coordinates: ${longitude}, ${latitude}`);
  };

  return (
    <>
      <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
        <div className="row g-0" style={{ height: "75vh", overflow: "hidden" }}>
          {/* Left Panel - Event Details with scrollbar */}
          <div className="col-md-6 p-4 bg-white" style={{ height: "100vh" }}>
            {/* Grid Layout for Event Details - 3 columns with reduced spacing */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "20px",
                marginBottom: "20px",
              }}
            >
              {/* First row */}
              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  ATM Name
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {atm.name}
                </p>
              </div>
              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  ATM Code
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {atm.code}
                </p>
              </div>
              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  Bank Name
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {bank?.bankName}
                </p>
              </div>

              {/* Second row */}

              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  Branch Name
                </p>
                <div
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {branch?.branchName}
                </div>
              </div>

              {/* Third row */}
              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  Mandal
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {atm.mandal}
                </p>
              </div>
              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  City
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {atm.city}
                </p>
              </div>
              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  District
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {atm.district}
                </p>
              </div>
              <div>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  Pincode
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {atm.pinCode}
                </p>
              </div>
              <div>
                <p
                  className="mb-1 small"
                  style={{ color: "#FFA100", fontSize: "13px" }}
                >
                  Active status
                </p>
                <p className="mb-0" style={{ fontSize: "15px" }}>
                  <span
                    className={`badge ${
                      atm?.activeStatus ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {atm?.activeStatus ? "Active" : "Inactive"}
                  </span>
                </p>
              </div>
              <div style={{ gridColumn: "span 2" }}>
                <p
                  className="mb-1 small"
                  style={{
                    color: "#FFA100",
                    fontFamily: "Poppins",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  Address
                </p>
                <p
                  className="mb-0"
                  style={{
                    color: "#000000",
                    fontFamily: "Poppins",
                    fontSize: "15px",
                    fontWeight: "400",
                  }}
                >
                  {atm.addressLine || "NA"}
                </p>
              </div>
            </div>
          </div>

          {/* Right Panel - Map with MapWrapper component */}
          <div
            className="col-md-6 p-0 "
            style={{
              overflow: "hidden",
              height: "500px",
              marginLeft: "-100px",
              width: "650px",
            }}
          >
            <MapWrapper
              title={mapTitle}
              selectedOption={selectedMapOption}
              onChangeHandler={handleMapOptionChange}
              containerStyles={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
              headerStyles={{
                backgroundColor: "#1a7a73",
                color: "white",
                padding: "8px 16px",
              }}
              bodyStyles={{
                flex: 1,
                overflow: "hidden",
              }}
              coordinates={mapCoordinates}
              chooseCoordinates={handleChooseCoordinates}
              zoom={13}
              popUpShow={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AtmDetailsView;
